import axios from 'axios';
import store from '@/store';
import router from '@/router';
import i18n from '@/i18n';

import utilities from '@/helpers/utilities';

const http = axios.create({
    baseURL: process.env.API_URL_NOVA,
});

http.interceptors.request.use((config) => {
    // Insert the authentication header
    if (!utilities.isEmpty(store.getters.profile)) {
        const token = store.getters.profile.token;
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
}, error => Promise.reject(error));

http.interceptors.response.use(response => response, ({ response }) => {
    // Server didn't answer
    if (utilities.isEmpty(response)) {
        store.dispatch('setApiEvent', i18n.t('message.error.networkError'));
        router.push({ name: 'httpError', params: { id: 404 } });
        return Promise.reject(response);
    }

    // Token expired or the credentials are invalid
    if (response.status === 401) {
        store.dispatch('showError', response.data.message);
        router.push({ name: response.data.code === 'cac_login_expired' ? 'expiredPassword' : 'login' });
        return Promise.reject(response);
    }

    // Custom Application error
    if (!utilities.isEmpty(response.data) && !utilities.isEmpty(response.data.message)) {
        store.dispatch('setApiEvent', response.data.developerMessage || response.data.message);
        router.push({ name: 'httpError', params: { id: response.status } });
        return Promise.reject(response);
    }

    // Something went very wrong
    store.dispatch('setApiEvent', i18n.t('message.error.fatalError'));
    router.push({ name: 'httpError', params: { id: 500 } });
    return Promise.reject(response);
});

export default http;


// WEBPACK FOOTER //
// ./src/httpNovoEndpoint/index.js